import { useTranslation } from "react-i18next";
import { errorCode } from "../api/client";

export const useApiError = () => {
  const { t } = useTranslation();
  return (error) => {
    const detail = errorCode(error);
    const key = detail.code || "generic";
    const params = {
      distance: detail.distance_m,
      radius: detail.radius_m,
      similarity: detail.similarity,
      minutes: detail.remaining_minutes,
      late: detail.late_minutes,
      allowed: detail.allowed_minutes,
      month: detail.month,
      deadline: detail.deadline_local,
      opens: detail.opens_local,
      grace: detail.grace_minutes,
      from: detail.period_start,
      to: detail.period_end,
      date: detail.date,
    };
    const authKey = `auth.${key}`;
    const errKey = `errors.${key}`;
    if (key !== "generic" && t(errKey, params) !== errKey) return t(errKey, params);
    if (t(authKey) !== authKey) return t(authKey);
    return detail.msg || t("errors.generic");
  };
};
